import { render, staticRenderFns } from "./ShowProduct.vue?vue&type=template&id=df68c770&scoped=true"
import script from "./ShowProduct.vue?vue&type=script&lang=js"
export * from "./ShowProduct.vue?vue&type=script&lang=js"
import style0 from "./ShowProduct.vue?vue&type=style&index=0&id=df68c770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df68c770",
  null
  
)

export default component.exports